import { render, staticRenderFns } from "./DataList.vue?vue&type=template&id=099b96fe&scoped=true&"
import script from "./DataList.vue?vue&type=script&lang=js&"
export * from "./DataList.vue?vue&type=script&lang=js&"
import style0 from "./DataList.vue?vue&type=style&index=0&id=099b96fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099b96fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('099b96fe')) {
      api.createRecord('099b96fe', component.options)
    } else {
      api.reload('099b96fe', component.options)
    }
    module.hot.accept("./DataList.vue?vue&type=template&id=099b96fe&scoped=true&", function () {
      api.rerender('099b96fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/submit-application/components/DataList.vue"
export default component.exports